module.exports = __webpack_public_path__ + "static/fonts/Robotoitalic.9da6e8b1.ttf";